import React from 'react';
import { useIsDesktopDimension } from '@beef/ui-kit/hooks';
import { NText } from '@fttb/common/components';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var TariffBenefitsItemContent = function TariffBenefitsItemContent(_ref) {
  var description = _ref.description,
    text = _ref.text,
    url = _ref.url;
  var IsDesktop = useIsDesktopDimension();
  return /*#__PURE__*/React.createElement("div", {
    className: cn('content'),
    "data-t-id": "components-TariffBenefitsItemContent"
  }, url && /*#__PURE__*/React.createElement("img", {
    alt: description || text,
    className: cn(text ? 'iconOffset' : 'common_icon'),
    src: url
  }), text && IsDesktop && /*#__PURE__*/React.createElement(NText, {
    size: "size5-r-l"
  }, text));
};
TariffBenefitsItemContent.propTypes = process.env.NODE_ENV !== "production" ? {
  description: PropTypes.string,
  text: PropTypes.string,
  url: PropTypes.string
} : {};